module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1IiBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgNSAxMCI+CiAgICA8cGF0aCBmaWxsPSIjNEM1NjY5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDBMMCA1bDUgNVYwIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery-arrow.svg
// module id = WaW3
// module chunks = 0